export const ensureLinkHasProtocol = (src: string): string => {
  return src.replace(/^\/\//, 'https://')
}
